var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"fill":"none","height":"28","viewBox":"0 0 40 28","width":"40","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M40 .667H0v26.667h40z","fill":"#f0f0f0"}}),_c('path',{attrs:{"d":"M40 12.333v3.333H14.348v11.667h-3.334V15.666H0v-3.333h11.014V.666h3.334v11.667z","fill":"#2e52b2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }